import voca from "voca";

import { BusinessBranchAttributes } from "../attributes/business-branch-attributes";
import Business from "./Business";
import BranchManager from "./BranchManager";
import Announcement from "./Announcement";
import { AnnouncementsAttributes } from "../attributes/announcements-attributes";

class BusinessBranch {
  id: number;
  name: string;
  code: string | null;
  address: string;
  latitude: string | null;
  longitude: string | null;

  manager?: BranchManager;
  business?: Business;
  branch_announcements?: Array<Announcement>;

  constructor(
    id: number,
    name: string,
    code: string | null,
    address: string,
    latitude: string | null,
    longitude: string | null,
    manager: BranchManager,
    business: Business,
    branch_announcements?: Array<Announcement>
  ) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.address = address;
    this.latitude = latitude;
    this.longitude = longitude;
    this.manager = manager;
    this.business = business;
    this.branch_announcements = branch_announcements;
  }

  static fromJson(json: BusinessBranchAttributes): BusinessBranch | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new BusinessBranch(
      json.id,
      json.name,
      json.code,
      json.address,
      json.latitude,
      json.longitude,
      BranchManager.fromJson(json.manager),
      Business.fromJson(json.business),
      BusinessBranch.jsonToAnnouncements(json.branch_announcements)
    );
  }

  avatar = (): string => {
    if (this.business !== null) {
      return this.business.company_logo;
    }

    return "";
  };

  fullName = (): string => {
    return voca.titleCase(this.name);
  };

  hasAManager = (): boolean => {
    return this.manager !== null;
  };

  fullAddress = (): string => {
    return voca.titleCase(this.address);
  };

  static jsonToAnnouncements(
    json: Array<AnnouncementsAttributes>
  ): Array<Announcement> {
    if (json === null || json === undefined) {
      return [];
    }

    return json.map((item) => Announcement.fromJson(item));
  }
}

export default BusinessBranch;
